var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsBuilding = function SvgIconsBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.818 14.667H8.606v-1.212h1.212v1.212m2.424-1.212H11.03v1.212h1.212v-1.212M9.818 11.03H8.606v1.212h1.212V11.03M4.97 13.455H3.758v1.212H4.97v-1.212m0-2.425H3.758v1.212H4.97V11.03m7.272 0H11.03v1.212h1.212V11.03M9.818 8.606H8.606v1.212h1.212V8.606m2.424 0H11.03v1.212h1.212V8.606m1.213-2.424c.669 0 1.212.543 1.212 1.212v7.273h-1.212V7.394H7.394v7.273H6.182V9.818H2.545v4.849H1.333V9.818c0-.67.543-1.212 1.212-1.212h3.637V7.394c0-.67.543-1.212 1.212-1.212V4.97c0-.67.543-1.212 1.212-1.212h1.212V1.333h1.212v2.425h1.212c.67 0 1.213.542 1.213 1.212v1.212m-1.213 0V4.97H8.606v1.212h3.636z"
  })));
};
export default SvgIconsBuilding;